import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  Input,
  HostListener,
} from "@angular/core";
import { LocationType } from "../models/location-type";
import { StandardService } from "../services/standard.service";
import { Category } from "../models/category";
import { FilteringGuide } from "../models/filteringGuide";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";
import { Location } from "@angular/common";
import { sortWithSelectedFirst, shouldShowSelectedDivider } from "../core/filter-utils";

@Component({
  selector: "app-view-all-mnimum-sandard-list-filter",
  templateUrl: "./view-all-mnimum-sandard-list-filter.component.html",
  styleUrls: ["./view-all-mnimum-sandard-list-filter.component.scss"],
})
export class ViewAllMnimumSandardListFilterComponent implements OnInit {
  locationTypes: LocationType[] = [];
  buildingCategories: Category[] = [];
  filterList: FilteringGuide[] = [];
  filteringForCheckBox: FilteringGuide[] = [];

  isCategoryDropdownOpen: boolean = false;
  categorySearchText: string = "";
  filteredCategories: Category[] = [];

  isLocationDropdownOpen: boolean = false;
  locationSearchText: string = "";
  filteredLocations: LocationType[] = [];

  @Output() messageEvent = new EventEmitter<Array<FilteringGuide>>();
  @Input() isFromLocation: boolean;

  constructor(
    public standardService: StandardService,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private cryptographyService: CryptographyService,
    private location: Location
  ) {}

  ngOnInit() {
    this.getMasterDataForFilteration();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isCategoryDropdownOpen = false;
      this.isLocationDropdownOpen = false;
    }
  }

  isLocationGRSList() {
    return this.location.path().includes("location-grs-list");
  }

  getMasterDataForFilteration() {
    this.standardService
      .GetMasterDataForAddNrbes(
        this.cryptographyService.decryptData(this.storage.get("userRole")),
        this.cryptographyService.decryptData(this.storage.get("userId"))
      )
      .subscribe((data: any) => {
        this.buildingCategories = data.buildingStandardCategories || [];
        this.locationTypes = data.locationTypes || [];
        this.filterItems("category");
        this.filterItems("location");
      });
  }

  toggleDropdown(type: string) {
    if (type === "category") {
      this.isCategoryDropdownOpen = !this.isCategoryDropdownOpen;
      this.isLocationDropdownOpen = false;
      if (this.isCategoryDropdownOpen) {
        this.categorySearchText = "";
        this.filterItems("category");
      }
    } else if (type === "location") {
      this.isLocationDropdownOpen = !this.isLocationDropdownOpen;
      this.isCategoryDropdownOpen = false;
      if (this.isLocationDropdownOpen) {
        this.locationSearchText = "";
        this.filterItems("location");
      }
    }
  }

  filterItems(type: string) {
    if (type === "category") {
      const search = (this.categorySearchText || "").toLowerCase().trim();
      const filtered = search
        ? this.buildingCategories.filter((c) => c.name.toLowerCase().includes(search))
        : [...this.buildingCategories];
      this.filteredCategories = sortWithSelectedFirst(filtered, (id) =>
        this.setCheckedStateForCheckBoxes(2, id)
      );
    } else if (type === "location") {
      const search = (this.locationSearchText || "").toLowerCase().trim();
      const filtered = search
        ? this.locationTypes.filter((l) => l.name.toLowerCase().includes(search))
        : [...this.locationTypes];
      this.filteredLocations = sortWithSelectedFirst(filtered, (id) =>
        this.setCheckedStateForCheckBoxes(1, id)
      );
    }
  }

  getSelectedItemsCount(type: string): number[] {
    const filterType = type === "category" ? 2 : 1;
    this.filteringForCheckBox =
      this.standardService.minimumStandardFiltration.filterSet;
    if (this.filteringForCheckBox) {
      const found = this.filteringForCheckBox.find((i) => i.type === filterType);
      return found ? found.ids : [];
    }
    return [];
  }

  getDisplayText(type: string): string {
    const count = this.getSelectedItemsCount(type).length;
    return count > 0 ? `${count}` : "";
  }

  showFilterClearButton(type: string): boolean {
    return this.getSelectedItemsCount(type).length > 0;
  }

  removeSelected(type: string, event: Event) {
    event.stopPropagation();
    const filterType = type === "category" ? 2 : 1;
    if (this.filterList) {
      const index = this.filterList.findIndex((i) => i.type === filterType);
      if (index > -1) {
        this.filterList.splice(index, 1);
      }
    }
    this.standardService.minimumStandardFiltration.filterSet = this.filterList;
    this.filterItems(type);
    this.messageEvent.emit(this.filterList);
  }

  showFilterDivider(items: any[], index: number, filterType: number): boolean {
    return shouldShowSelectedDivider(items, index, (id) =>
      this.setCheckedStateForCheckBoxes(filterType, id)
    );
  }

  applyFilters() {
    this.isCategoryDropdownOpen = false;
    this.isLocationDropdownOpen = false;
    this.messageEvent.emit(this.filterList);
  }

  addFilter($event: any, id: number, filterParam: number) {
    if (this.standardService.minimumStandardFiltration.filterSet != null) {
      this.filterList =
        this.standardService.minimumStandardFiltration.filterSet;
    }
    if ($event.checked) {
      let filterGuide = this.filterList.find((i) => i.type === filterParam);
      if (filterGuide != undefined) {
        if (!filterGuide.ids.includes(id)) {
          filterGuide.ids.push(id);
        }
      } else {
        let guide = new FilteringGuide();
        guide.type = filterParam;
        guide.ids.push(id);
        this.filterList.push(guide);
      }
    } else {
      let selectedFilter = this.filterList.find((i) => i.type === filterParam);
      if (selectedFilter != undefined && selectedFilter.ids.includes(id)) {
        let index = selectedFilter.ids.indexOf(id);
        selectedFilter.ids.splice(index, 1);
      }
      if (selectedFilter && selectedFilter.ids.length == 0) {
        let i = this.filterList.findIndex((x) => x.type === filterParam);
        this.filterList.splice(i, 1);
      }
    }
    this.standardService.minimumStandardFiltration.filterSet = this.filterList;
    this.filterItems(filterParam === 2 ? "category" : "location");
  }

  setCheckedStateForCheckBoxes(type: number, id: number): boolean {
    this.filteringForCheckBox =
      this.standardService.minimumStandardFiltration.filterSet;
    if (this.filteringForCheckBox != null) {
      let t = this.filteringForCheckBox.find((i) => i.type === type);
      if (t != undefined && t.ids.includes(id)) {
        return true;
      }
    }
    return false;
  }
}
